const mediaItems = [
  {
    title: '《暗夜追踪》独家预告首发',
    desc: '年度悬疑大片即将登陆蚂蚁影视，高智商犯罪与反转剧情，带你体验肾上腺素飙升的观影快感。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20dark%20thriller%20scene%20with%20moody%20amber%20lighting%2C%20shadowy%20urban%20alley%20at%20night%2C%20film%20noir%20aesthetic%2C%20dramatic%20contrast%2C%20mysterious%20atmosphere%2C%20warm%20golden%20light%20streaks%2C%20cinematic%20photography&width=800&height=450&seq=media-card-01&orientation=landscape',
    tag: '独家预告',
    duration: '02:38',
    views: '126万次播放',
  },
  {
    title: '《星辰大海》幕后纪录片',
    desc: '走进国产科幻巨制的创作幕后，揭秘顶级特效团队如何打造震撼视觉奇观。',
    img: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20scene%20with%20warm%20golden%20nebula%20and%20stars%2C%20cinematic%20space%20atmosphere%2C%20soft%20amber%20glow%2C%20artistic%20abstract%20cosmic%20composition%2C%20deep%20charcoal%20background%2C%20dramatic%20lighting&width=800&height=450&seq=media-card-02&orientation=landscape',
    tag: '幕后花絮',
    duration: '15:42',
    views: '89万次播放',
  },
  {
    title: '暑期档必看片单盘点',
    desc: '蚂蚁影视精选暑期不可错过的十部佳作，从动作到喜剧，承包你整个夏天的追剧时光。',
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20summer%20cinematic%20scene%20with%20golden%20hour%20sunlight%2C%20outdoor%20movie%20screen%20setup%2C%20cozy%20atmosphere%2C%20soft%20warm%20tones%2C%20film%20reel%20aesthetic%2C%20nostalgic%20vibe%2C%20cinematic%20photography&width=800&height=450&seq=media-card-03&orientation=landscape',
    tag: '片单推荐',
    duration: '08:15',
    views: '203万次播放',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            精彩视频
          </h2>
          <p className="mt-3 text-foreground-400 text-sm">
            预告、花絮、片单盘点，影迷专属视频内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-300/30 rounded-xl overflow-hidden hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={`蚂蚁影视 ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="800"
                  height="450"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <span className="px-2 py-1 text-[11px] font-medium bg-primary-500 text-background-950 rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-300 flex items-center gap-1">
                    <i className="ri-play-circle-line"></i>
                    {item.duration}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="text-[11px] text-foreground-300 bg-background-950/60 px-2 py-1 rounded-md">
                    {item.views}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}